import { Injectable } from '@angular/core';
import {
    ReportMenuData,
    ReportMenuBookmarkForm,
    ReportMenuModuleItems,
} from '../interfaces/report-menu-data';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ReportService {
    constructor(private _http: HttpClient) {}

    getReports(): Observable<ReportMenuData[]> {
        return this._http.get<ReportMenuData[]>(
            'https://' + window.location.host + '/api/v0.5/reportmenu/getreports/'
        );
    }

    updateReportBookmark(data: ReportMenuBookmarkForm): Observable<{}> {
        return this._http.post(
            `https://${window.location.host}/api/v0.5/reportmenu/bookmark/`,
            data
        );
    }

    getModules(): Observable<ReportMenuModuleItems[]> {
        return this._http.get<ReportMenuModuleItems[]>(
            'https://' + window.location.host + '/api/v0.5/reportmenu/getmodules/'
        );
    }
}
